<template>
  <v-container style="height: 100%" fluid>
    <BackButton />

    <div v-if="loading" class="loader-block">
      <Loader />
    </div>

    <div v-else>
      <!-- Title -->
      <v-row justify="center">
        <v-col cols="12" sm="12" md="6">
          <v-card flat>
            <v-card-title class="justify-center">{{ $t('addShooting.addShooting') }}</v-card-title>
          </v-card>
        </v-col>
      </v-row>

      <!-- search Immat -->
      <v-row justify="center">
        <v-col cols="12" sm="12" md="6">
          <RegistrationSelect :registrations="products" />
        </v-col>
      </v-row>

      <!-- select format -->
      <v-row justify="center">
        <v-col cols="12" sm="12" md="6">
          <SelectFormat :registrations="products" />
        </v-col>
      </v-row>

      <!-- Owner -->
      <v-row v-if="active && registration !== '' && format !== ''" justify="center">
        <v-col cols="12" sm="12" md="6">
          <SelectFieldStock v-on:change-value="changeValue" :owners="labelsOwner" />
        </v-col>
      </v-row>

      <!-- Select Stamp -->
      <v-row v-if="registration !== '' && format !== ''" justify="center">
        <v-col cols="12" sm="12" md="6">
          <SelectStamp />
        </v-col>
      </v-row>

      <!-- Drag photos -->
      <v-row v-if="registration !== '' && format !== ''" justify="center">
        <v-col cols="12" sm="12" md="6">
          <DragAndDrop />
        </v-col>
      </v-row>

      <!-- Send shooting -->
      <v-row justify="center">
        <v-col cols="12" sm="12" md="6">
          <div class="end-block">
            <ModalSendShooting :active="active" :valid="valid" />
          </div>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'

import DragAndDrop from '@/components/addShooting/DragAndDrop.vue'
import SelectFieldStock from '@/components/common/organims/SelectFieldStock.vue'
import SelectStamp from '@/components/addShooting/SelectStamp.vue'
import SelectFormat from '@/components/addShooting/SelectFormat.vue'
import RegistrationSelect from '@/components/addShooting/RegistrationSelect.vue'
import ModalSendShooting from '@/components/addShooting/ModalSendShooting.vue'
import Loader from '@/components/Loader'
import BackButton from '@/components/BackButton'

export default {
  name: 'AddShooting',
  components: {
    DragAndDrop,
    SelectFieldStock,
    SelectStamp,
    RegistrationSelect,
    ModalSendShooting,
    Loader,
    BackButton,
    SelectFormat
  },
  computed: {
    ...mapState({
      owners: state => state.owners,
      loading: state => state.loading,
      status: state => state.newShooting.status,
      owner: state => state.newShooting.owner,
      registration: state => state.newShooting.registration,
      stampExist: state => !!(state.newShooting && state.newShooting.stamp),
      stamps: state => state.stamps,
      format: state => state.newShooting.format,
      shooting: state => state.newShooting.shooting,
      labelsOwner: state => state.labelsOwner,
      products: state => state.products
    }),
    valid() {
      return this.registration !== '' && this.owner !== '' && this.shooting.length !== 0 && this.stampExist
    },
    active() {
      return this.status === 'create'
    }
  },

  created() {
    this.getProducts()
    this.getLabelOwner(this.owners)
  },

  destroyed() {
    this.$store.commit('RESET_ADD_SHOOTING_FORM')
  },

  methods: {
    async getLabelOwner(owners) {
      const res = await this.$store.dispatch('getLabelOwner', owners)

      if (!res || this.labelsOwner.length === 0) return
      else if (this.labelsOwner.length === 1) {
        const owner = this.labelsOwner[0].ownerId
        this.$store.commit('UPDATE_OWNER', owner)
      }
    },
    getProducts(owners) {
      this.$store.dispatch('getProducts', owners)
    },

    changeValue(ob) {
      const { name, value } = ob
      this.$store.commit('UPDATE_OWNER', value)
    }
  }
}
</script>

<style lang="sass" scoped>
.backButton-block
  padding: 20px

.loader-block
  width: 100%
  height: 100%
  display: flex
  justify-content: center
  align-items: center

.end-block
  display: flex
  justify-content: flex-end

p
  text-align: center
  font-size: 16px
  color: rgba(0, 0, 0, 0.7)
</style>
